import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFontFamilyResolver
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.platform.Font
import androidx.compose.ui.window.ComposeViewport
import com.nonopn.skydome.management.app.home.App
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.jetbrains.skiko.wasm.onWasmReady
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Int8Array

// Subsets of Noto Sans Math / Noto Color Emoji (SIL OFL), served next to index.html.
// Roboto has no emoji, arrows or geometric shapes: without these fallbacks they render as squares.
private val fallbackFontFiles = listOf("/SymbolsFallback.ttf", "/EmojiFallback.ttf")

@OptIn(ExperimentalJsExport::class, ExperimentalComposeUiApi::class)
@JsExport
fun main() {
    onWasmReady {
        ComposeViewport(
            content = {
                // no need to set custom configureWebResources with { path -> "/$path" } anymore
                WithFallbackFonts {
                    Column(modifier = Modifier.fillMaxSize()) {
                        App(isSystemInDarkTheme())
                    }
                }
            })
    }
}

@Composable
private fun WithFallbackFonts(content: @Composable () -> Unit) {
    val fontFamilyResolver = LocalFontFamilyResolver.current
    var fontsReady by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        fallbackFontFiles.forEach { file ->
            runCatching {
                val response = window.fetch(file).await()
                if (response.ok) {
                    val buffer: ArrayBuffer = response.arrayBuffer().await()
                    val bytes = Int8Array(buffer).unsafeCast<ByteArray>()
                    fontFamilyResolver.preload(FontFamily(Font(file, bytes)))
                }
            }
        }
        fontsReady = true
    }

    if (fontsReady) {
        content()
    }
}
